/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  reauthorize(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reauthorize`);
  }

  // Recupera il refresh_counter dell'inbox per il polling frontend
  getRefreshToken(inboxId) {
    return axios
      .get(`${this.url}/${inboxId}/refresh_token`)
      .then((r) => r.data);
  }

  // Refresh dei conteggi delle label Gmail
  refreshGmailCounts(inboxId) {
    return axios.post(`${this.url}/${inboxId}/refresh_gmail_counts`);
  }

  requestConversationExportOtp(inboxId) {
    return axios.post(`${this.url}/${inboxId}/conversation_exports/otp`);
  }

  createConversationExport(inboxId, params) {
    return axios.post(`${this.url}/${inboxId}/conversation_exports`, params);
  }

  getDeletionStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/deletion_status`);
  }
}

export default new Inboxes();
